import { Linking, Platform } from 'react-native';
import { doc, getDoc } from 'firebase/firestore';
import { firestore } from '../services/firebase';
import { COURSES, PLANS, PRODUCTS } from '../constants/entities';

function openExternalUrl(url) {
  if (Platform.OS === 'web' && typeof document !== 'undefined') {
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.target = '_self';
    anchor.click();
    return;
  }
  Linking.openURL(url);
}

export function buildCheckoutUrlWithUserParams(url, user) {
  if (!url) return null;

  let checkoutUrlWithParams = url;

  if (user?.Nome_Completo !== undefined) {
    checkoutUrlWithParams += `${checkoutUrlWithParams.includes('?') ? '&' : '?'}name=${encodeURIComponent(
      user.Nome_Completo
    )}`;
  }
  if (user?.Email !== undefined) {
    checkoutUrlWithParams += `${checkoutUrlWithParams.includes('?') ? '&' : '?'}email=${encodeURIComponent(
      user.Email
    )}`;
  }
  if (user?.Celular !== undefined) {
    checkoutUrlWithParams += `${checkoutUrlWithParams.includes('?') ? '&' : '?'}phone_number=${encodeURIComponent(
      user.Celular
    )}`;
  }
  if (user?.Doc !== undefined) {
    checkoutUrlWithParams += `${checkoutUrlWithParams.includes('?') ? '&' : '?'}doc=${encodeURIComponent(
      user.Doc
    )}`;
  }

  return checkoutUrlWithParams;
}

/**
 * Abre o checkout do produto específico escolhido na vitrine (em vez do modal
 * com todas as opções equivalentes do módulo).
 */
export async function openCatalogProductCheckout({ catalogProductId, user, navigation }) {
  if (!catalogProductId) return false;

  const productSnap = await getDoc(doc(firestore, PRODUCTS, catalogProductId));
  if (productSnap.exists()) {
    const data = productSnap.data();
    if (!data.archived && data.marketplace !== 'IAP') {
      const url = buildCheckoutUrlWithUserParams(
        data.primaryCheckoutUrl || data.checkoutUrl,
        user
      );
      if (url) {
        Linking.openURL(url);
        return true;
      }
    }
  }

  const planSnap = await getDoc(doc(firestore, PLANS, catalogProductId));
  if (planSnap.exists()) {
    const data = planSnap.data();
    if (data?.hasOutsidePage && data?.salesPageUrl) {
      openExternalUrl(data.salesPageUrl);
      return true;
    }
    if (navigation) {
      navigation.navigate('Planos', {
        userId: user?.id,
        plan: user?.plan,
        firstPlanPurchase: user?.firstPlanPurchase,
        isAdmin: user?.isAdmin === true,
      });
      return true;
    }
  }

  const courseSnap = await getDoc(doc(firestore, COURSES, catalogProductId));
  if (courseSnap.exists()) {
    const data = courseSnap.data();
    if (data?.hasOutsidePage && data?.salesPageUrl) {
      openExternalUrl(data.salesPageUrl);
      return true;
    }
    if (navigation) {
      navigation.navigate('Produto', { courseId: catalogProductId });
      return true;
    }
  }

  return false;
}
